import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function About() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '黑料不打烊是一个什么样的平台？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '黑料不打烊是一个全天候追踪娱乐圈最新黑料、明星丑闻与幕后真相的深度爆料聚合平台。我们致力于为读者提供最劲爆、最及时的娱乐圈内幕信息，让你第一时间掌握圈内动态。',
        },
      },
      {
        '@type': 'Question',
        name: '平台的内容是否真实可靠？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们严格把关每一条爆料内容，所有发布的文章都经过多源交叉验证。虽然娱乐圈信息复杂多变，但我们承诺以最严谨的态度对待每一条信息，确保内容的真实性和可靠性。',
        },
      },
      {
        '@type': 'Question',
        name: '如何向平台提供爆料线索？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '你可以通过页面上的联系表单或发送邮件至 contact@heiliaobudaying.com 向我们提供爆料线索。我们会对爆料人的身份信息严格保密，绝不泄露。',
        },
      },
      {
        '@type': 'Question',
        name: '平台的内容更新频率是怎样的？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '正如我们的名字——黑料不打烊，我们全天候不间断更新内容。无论深夜还是清晨，只要娱乐圈有新的动态，我们都会第一时间为你呈现。平均每天更新10-20篇新鲜爆料。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系黑料不打烊团队？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '你可以通过以下方式联系我们：发送邮件至 contact@heiliaobudaying.com，或使用页面上的联系表单。我们会在24小时内回复你的消息。',
        },
      },
    ],
  };

  const aboutPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于黑料不打烊 - 娱乐圈深度爆料聚合平台',
    description: '了解黑料不打烊的品牌故事、团队背景、平台口碑以及联系方式。',
    url: 'https://heiliaobudaying.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '黑料不打烊',
      url: 'https://heiliaobudaying.com',
    },
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('idle');
    setFormError('');

    const form = e.currentTarget;
    const honeypotField = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypotField && honeypotField.value.trim() !== '') {
      setFormStatus('success');
      form.reset();
      return;
    }

    const formData = new FormData(form);

    try {
      const response = await fetch('https://readdy.ai/api/form/d9qs1ufnahb7382ovejg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg =
          parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
        if (typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam')) {
          setFormError('提交失败，请稍后重试');
        } else {
          setFormError(serverMsg);
        }
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查网络连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div className="w-full px-4 md:px-6 py-6">
            <div className="max-w-4xl mx-auto">
              <Breadcrumb items={breadcrumbItems} />

              {/* Hero */}
              <section className="mt-6 mb-12">
                <h1 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
                  关于 <strong>黑料不打烊</strong>
                </h1>
                <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl">
                  全天候追踪<strong>娱乐圈黑料</strong>、<strong>明星爆料</strong>与幕后真相。
                  无论深夜还是清晨，黑料不打烊为你持续更新最劲爆的内容。
                </p>
              </section>

              {/* Brand Story */}
              <section className="mb-12">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                    <i className="ri-bookmark-line text-white"></i>
                  </div>
                  <h2 className="text-xl font-bold font-heading text-foreground-900">品牌故事</h2>
                </div>
                <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
                  <p>
                    在这个信息爆炸的时代，<strong>娱乐圈黑料</strong>与<strong>明星爆料</strong>层出不穷，但真假难辨。
                    黑料不打烊应运而生，我们立志做一个有态度、有温度的<strong>娱乐八卦爆料</strong>平台。
                  </p>
                  <p>
                    我们的编辑团队由资深娱乐记者和行业内部人士组成，平均从业经验超过8年。凭借广泛的圈内人脉和专业的调查能力，
                    我们能够在第一时间获取最真实、最劲爆的<strong>圈内黑料</strong>，并以最快的速度呈现给读者。
                  </p>
                  <p>
                    "不打烊"不仅是我们对更新频率的承诺，更代表着我们对真相永不放弃的追求。在这个<strong>不打烊爆料平台</strong>上，
                    没有休息日，没有下班时间——哪里有<strong>最新丑闻</strong>，哪里就有我们的身影。
                  </p>
                </div>
              </section>

              {/* Stats */}
              <section className="mb-12">
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                  {[
                    { number: '12,000+', label: '累计爆料', icon: 'ri-article-line' },
                    { number: '860万+', label: '月活跃读者', icon: 'ri-user-line' },
                    { number: '96%', label: '读者满意度', icon: 'ri-heart-line' },
                    { number: '24/7', label: '全天候更新', icon: 'ri-timer-line' },
                  ].map((stat, i) => (
                    <div
                      key={i}
                      className="bg-background-50 rounded-xl border border-background-200/70 p-5 text-center"
                    >
                      <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center bg-primary-100 rounded-lg">
                        <i className={`${stat.icon} text-primary-600 text-lg`}></i>
                      </div>
                      <div className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
                        {stat.number}
                      </div>
                      <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                    </div>
                  ))}
                </div>
              </section>

              {/* Reputation */}
              <section className="mb-12">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 flex items-center justify-center bg-accent-500 rounded-lg">
                    <i className="ri-star-line text-white"></i>
                  </div>
                  <h2 className="text-xl font-bold font-heading text-foreground-900">用户口碑</h2>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {[
                    {
                      quote: '自从关注了黑料不打烊，再也不用担心错过任何娱乐圈大瓜了。更新速度真的太快了！',
                      author: '娱乐达人小王',
                      role: '忠实读者 3年',
                    },
                    {
                      quote: '内容质量很高，每篇爆料都有详细的证据链，不像其他平台只会跟风造谣。这才是真正的深度爆料。',
                      author: '媒体人老张',
                      role: '资深读者 2年',
                    },
                    {
                      quote: '圈内人都知道，黑料不打烊的消息来源非常可靠。很多所谓的\"独家新闻\"，其实都是从这里先发出来的。',
                      author: '匿名业内人士',
                      role: '行业内部读者',
                    },
                  ].map((review, i) => (
                    <div
                      key={i}
                      className="bg-background-50 rounded-xl border border-background-200/70 p-5"
                    >
                      <div className="flex gap-1 mb-3">
                        {[...Array(5)].map((_, j) => (
                          <i key={j} className="ri-star-fill text-accent-500 text-sm"></i>
                        ))}
                      </div>
                      <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                        "{review.quote}"
                      </p>
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full bg-secondary-200 flex items-center justify-center">
                          <i className="ri-user-line text-secondary-600 text-sm"></i>
                        </div>
                        <div>
                          <div className="text-sm font-medium text-foreground-900">{review.author}</div>
                          <div className="text-xs text-foreground-500">{review.role}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </section>

              {/* FAQ */}
              <section className="mb-12">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 flex items-center justify-center bg-secondary-500 rounded-lg">
                    <i className="ri-question-line text-white"></i>
                  </div>
                  <h2 className="text-xl font-bold font-heading text-foreground-900">常见问题</h2>
                </div>
                <div className="space-y-3">
                  {[
                    {
                      q: '黑料不打烊是一个什么样的平台？',
                      a: '黑料不打烊是一个全天候追踪娱乐圈最新黑料、明星丑闻与幕后真相的深度爆料聚合平台。我们致力于为读者提供最劲爆、最及时的娱乐圈内幕信息，让你第一时间掌握圈内动态。',
                    },
                    {
                      q: '平台的内容是否真实可靠？',
                      a: '我们严格把关每一条爆料内容，所有发布的文章都经过多源交叉验证。虽然娱乐圈信息复杂多变，但我们承诺以最严谨的态度对待每一条信息。',
                    },
                    {
                      q: '如何向平台提供爆料线索？',
                      a: '你可以通过下方的联系表单或发送邮件至 contact@heiliaobudaying.com 向我们提供爆料线索。我们会对爆料人的身份信息严格保密。',
                    },
                    {
                      q: '平台的内容更新频率是怎样的？',
                      a: '正如我们的名字——黑料不打烊，我们全天候不间断更新内容。无论深夜还是清晨，只要娱乐圈有新的动态，我们都会第一时间呈现。平均每天更新10-20篇新鲜爆料。',
                    },
                    {
                      q: '如何联系黑料不打烊团队？',
                      a: '你可以通过发送邮件至 contact@heiliaobudaying.com 或使用下方的联系表单。我们会在24小时内回复你的消息。',
                    },
                  ].map((faq, i) => (
                    <details
                      key={i}
                      className="bg-background-50 rounded-xl border border-background-200/70 group"
                    >
                      <summary className="px-5 py-4 cursor-pointer text-sm md:text-base font-medium text-foreground-900 flex items-center justify-between list-none">
                        <span>{faq.q}</span>
                        <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                      </summary>
                      <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                        {faq.a}
                      </div>
                    </details>
                  ))}
                </div>
              </section>

              {/* Contact Form */}
              <section className="mb-12">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                    <i className="ri-mail-send-line text-white"></i>
                  </div>
                  <h2 className="text-xl font-bold font-heading text-foreground-900">联系我们</h2>
                </div>
                <div className="bg-background-50 rounded-xl border border-background-200/70 p-6">
                  <form
                    onSubmit={handleSubmit}
                    className="space-y-4"
                    data-readdy-form
                  >
                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="contact-form-honeypot"
                    />
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div>
                        <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                          姓名 <span className="text-primary-500">*</span>
                        </label>
                        <input
                          type="text"
                          id="contact-name"
                          name="name"
                          required
                          className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-white text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                          placeholder="请输入你的姓名"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                          邮箱 <span className="text-primary-500">*</span>
                        </label>
                        <input
                          type="email"
                          id="contact-email"
                          name="email"
                          required
                          className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-white text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                          placeholder="请输入你的邮箱"
                        />
                      </div>
                    </div>
                    <div>
                      <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        主题
                      </label>
                      <input
                        type="text"
                        id="contact-subject"
                        name="subject"
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-white text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                        placeholder="请输入消息主题"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        消息内容 <span className="text-primary-500">*</span>
                      </label>
                      <textarea
                        id="contact-message"
                        name="message"
                        required
                        maxLength={500}
                        rows={5}
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-white text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                        placeholder="请输入你想说的话（限500字）"
                      ></textarea>
                      <p className="text-xs text-foreground-500 mt-1">最多500个字符</p>
                    </div>

                    {formStatus === 'error' && (
                      <div className="flex items-center gap-2 p-3 rounded-lg bg-primary-50 text-primary-700 text-sm">
                        <i className="ri-error-warning-line"></i>
                        <span>{formError}</span>
                      </div>
                    )}
                    {formStatus === 'success' && (
                      <div className="flex items-center gap-2 p-3 rounded-lg bg-accent-50 text-accent-700 text-sm">
                        <i className="ri-check-line"></i>
                        <span>感谢你的留言！我们会尽快回复。</span>
                      </div>
                    )}

                    <button
                      type="submit"
                      className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium transition-all whitespace-nowrap"
                    >
                      <i className="ri-send-plane-line"></i>
                      发送消息
                    </button>
                  </form>
                </div>
              </section>

              {/* Contact Info */}
              <section className="mb-12">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 text-center">
                    <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center bg-primary-100 rounded-lg">
                      <i className="ri-mail-line text-primary-600 text-lg"></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                    <p className="text-sm text-foreground-600">contact@heiliaobudaying.com</p>
                  </div>
                  <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 text-center">
                    <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center bg-accent-100 rounded-lg">
                      <i className="ri-map-pin-line text-accent-600 text-lg"></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">办公地址</h3>
                    <p className="text-sm text-foreground-600">北京市朝阳区建国路88号</p>
                  </div>
                  <div className="bg-background-50 rounded-xl border border-background-200/70 p-5 text-center">
                    <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center bg-secondary-100 rounded-lg">
                      <i className="ri-time-line text-secondary-600 text-lg"></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-900 mb-1">工作时间</h3>
                    <p className="text-sm text-foreground-600">7×24小时全天候</p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}